import React, { useState, useEffect, useLayoutEffect, useMemo } from 'react';
import { Table, Input, Select, Pagination } from 'antd';
import './TableList.scss';
import common from '../../common';
import { useSelector } from 'react-redux';
import { AiOutlineLike } from 'react-icons/ai';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



const { Option } = Select;




function TableList({ data = [], columns = [], pageSize = 10, categoryOptions = [], type = "Editor", eventAttenCount = '' } ) {
    const member_idx = useSelector((state) => state.user.loginInfo || null);

    const { useAlert, useLoading, useConfirm } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pConfirm, ConfirmComponent } = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();

    // 검색 카테고리 상태
    const [searchCategory, setSearchCategory] = useState('전체');
    // 검색 텍스트 상태
    const [searchText, setSearchText] = useState('');
    // 필터된 데이터 상태
    const [filteredData, setFilteredData] = useState([]);
    // 현재 페이지 상태
    const [currentPage, setCurrentPage] = useState(1);
    // 업데이트된 컬럼 상태
    const [updatedColumns, setUpdatedColumns] = useState([]);

    useEffect(() => {
        const fetchDataAndSetColumns = async () => {
            try {
                pLoadingOn();  // 로딩 시작
                setFilteredData(data); // 데이터 설정 중 오류 발생 가능
                updateColumns();
    
            } catch (error) {
                pLoadingOff();
                console.error('데이터 처리 중 오류 발생:', error);
            }
        };
    
        fetchDataAndSetColumns();
    }, [data, columns]);

    useLayoutEffect(() => {
        if(filteredData == []){
            pLoadingOff();
        }

        if(data.length === 0){
            pLoadingOff();
        }

        if (updatedColumns.length > 0 && filteredData.length > 0) {
            pLoadingOff();  // 모든 렌더링이 완료된 후 로딩 종료
        }
    }, [updatedColumns, filteredData]);

    const cols = useMemo(() => {
        return (columns || []).map(col => {
            if (col.dataIndex === 'thumbnail') {
                return {
                    ...col,
                    render: (text, record) => (
                        <img src={record.thumbnail || '/img/logo2.png'} alt="thumbnail" style={{ width: '80px', height: '80px', objectFit: 'cover', backgroundColor: '#eee'}} />
                    )
                };
            } else if (col.dataIndex === 'user_name') {
                return {
                    ...col,
                    render: (text, record) => (
                        <>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                gap: '5px'
                            }}>
                                <img 
                                    src={`/img/${record.gradeImg || 'userImg.png'}`} 
                                    alt="gradeImg" 
                                    style={{ width: '20px', height: '20px', objectFit: 'cover' }} 
                                />
                                <span>{record.name}</span>
                            </div>
                            
                        </>
                    )
                };
            } 
            // else if (col.dataIndex === 'user_thumbnail') {
            //     return {
            //         ...col,
            //         render: (text, record) => (
            //             <>
            //                 {(!member_idx || (typeof member_idx === 'object' && Object.keys(member_idx).length === 0)) ? (
            //                     <img src={'/img/logo2.png'} alt="thumbnail" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
            //                 ) : (
            //                     <img src={record.thumbnail || '/img/logo2.png'} alt="thumbnail" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
            //                 )}
            //             </>
            //         )
            //     };
            // }
            else if (col.dataIndex === 'user_university') {
                return {
                    ...col,
                    render: (text, record) => (
                        <div>
                            {record.university || record.major ? (
                                <>
                                    
                                    {record.degree ? `[${record.degree}]` : ''} {record.university || '-'}
                                    {' | '}
                                    {record.major || '-'} {record.degreeAttend}
                                </>
                            ) : (
                                '-'
                            )}
                        </div>
                    )
                };
            } else if (col.dataIndex === 'event_title') {
                return {
                    ...col,
                    render: (text, record) => {
                        const statusStyles = (distinction) => ({
                            display: 'inline-block',
                            width: '40px',
                            backgroundColor:
                                distinction === 'BEFORE' ? 'blue' :
                                distinction === 'NOW' ? 'red' :
                                distinction === 'AFTER' ? 'gray' : 'transparent', // 예약: 파란색, 모집중: 빨간색, 마감: 회색
                            color: 'white',
                            borderRadius: '5px',
                            fontSize: '12px',
                            textAlign: 'center',
                        });
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                <img src={record.thumbnail || '/img/logo2.png'} alt="thumbnail" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                                <div>
                                    <div style={{ lineHeight:'24px', marginBottom: '8px',display:'block',width:'70%' }}> {/* 줄바꿈을 위한 margin 추가 */}
                                        <span style={statusStyles(record.distinction)}>
                                            {record.distinction === 'BEFORE' ? '예약' : record.distinction === 'NOW' ? '모집중' : record.distinction === 'AFTER' ? '마감' : ''}
                                        </span>
                                    </div>
                                    <div style={{ lineHeight:'24px', marginBottom: '8px',display:'block',width:'100%', whiteSpace: 'normal' }}> {/* 줄바꿈을 위한 margin 추가 */}
                                        {record.writeType === 'Y' && <span
                                        style={{
                                            backgroundColor: "#ff0",
                                            fontWeight: "600",
                                            padding: "2px 7px",
                                            marginRight: "5px",
                                            color: "#f00",
                                            borderRadius: "4px"
                                        }}
                                        >중요</span>}
                                        <b style={{ fontWeight: 'bold', fontSize: '16px' }}>[{record.cate || '기타'}]</b>
                                        
                                        <span style={{ fontSize: '16px', fontWeight: 'normal' }}>{record.title}</span>
                                    </div>
                                    <div style={{ lineHeight:'24px', display:'block',width:'100%', whiteSpace: 'normal'}}> {/* 줄바꿈을 위한 margin 추가 */}
                                        <div style={{ color: '#9e9e9e', fontSize: '14px' }}>
                                            {`행사기간: ${record.date} | 장소: ${record.place || '-'} | `} 
                                            <AiOutlineLike /> {record.likeCount}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }
                };
            } else if (col.dataIndex === 'ex') {
                return {
                    ...col,
                    render: (text, record) => (
                        member_idx === record.memberIDX ? (
                            <div>
                                <input 
                                    type="text"
                                    className='ex_input'
                                    placeholder='내용 입력 후 엔터를 눌러주세요.'
                                    defaultValue={text}
                                    onKeyDown={(e) => handleInputKeyPress(e, record)}  // 엔터 키 누를 시 호출
                                />
                            </div>
                        ) : (
                            <span>{text}</span>  // 항상 ex 값을 보이게 설정
                        )
                    )
                };
            } else if (col.dataIndex === 'title') {
                return {
                    ...col,
                    render: (text, record) => (
                        <span>
                            {record.writeType === 'Y' && <span
                            style={{
                                backgroundColor: "#ff0",
                                fontWeight: "600",
                                padding: "2px 7px",
                                marginRight: "5px",
                                color: "#f00",
                                borderRadius: "4px"
                            }}
                            >중요</span>}
                            {record.title}
                        </span>
                    )
                };
            } 
            return col;
        });
    }, [columns, member_idx]);




    const handleInputChange = async (value, record) => {
        const eventIDX = record.idx;
    
        pConfirm(
            '메모', 
            '메모를 작성 하시겠습니까?', 
            '350px', 
            'auto', 
            async () => {
                try {
                    const response = await axios.post(`${API_BASE_URL}/yehs_event/in/yehs_event_regist_memo_insert`, { eventIDX: parseInt(eventIDX), value: value }, {
                        withCredentials: true
                    });
                    if (response.data.result === 't') {
                        pAlert('메모 작성이 완료되었습니다.');
                    } else {
                        pAlert(response.data.msg);
                    }
                } catch (error) {
                    console.error('등록 실패:', error);
                    pAlert('등록에 실패했습니다. 다시 시도해 주세요.');
                } finally {
                    pLoadingOff();
                }
            },
            '확인', 
            '취소'
        );
    };
    
    const handleInputKeyPress = (event, record) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // 기본 엔터 동작을 막음
            handleInputChange(event.target.value, record);
        }
    };


    const updateColumns = () => {
        setUpdatedColumns(cols);
    };

    // 검색 카테고리 변경 핸들러
    const handleSearchCategoryChange = (value) => {
        setSearchCategory(value);
        handleSearch(searchText, value);  // 카테고리가 변경될 때 해당 카테고리로 검색
    };

    // 검색 텍스트 변경 핸들러
    const handleSearchTextChange = (e) => {
        const value = e.target.value;
        setSearchText(value);
        handleSearch(value, searchCategory);  // 텍스트 변경 시 현재 카테고리로 검색
    };

    const handleSearch = (text, category) => {
        if (text === '') {
            setFilteredData(data);
            return;
        }

        const filtered = data.filter(item => {
            if (category === '전체') {
                // 아이템 객체의 모든 필드를 확인합니다.
                return Object.values(item).some(value =>
                    typeof value === 'string' && value.includes(text)
                );
            } else {
                // 특정 카테고리만 확인합니다.
                const value = item[category];
                return value && typeof value === 'string' && value.includes(text);
            }
        });

        setFilteredData(filtered);
    };

    // 페이지 변경 핸들러
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleRowClick = (record) => {
        if (type === "Editor") {
            window.location.href = `/noticedetail?id=${record.idx}&type=document`;
        } else if (type === "User") {
            window.location.href = `/userdetail?id=${record.idx}`;
        } else if (type === "Event") {
            window.location.href = `/noticedetail?id=${record.idx}&type=Event`;
        } else if (type === "EventRegist") {
            return;
        }
    };

    return (
        <>
            <AlertComponent/>
            <LoadingComponent/>
            <ConfirmComponent/>
            <div className='p_tableList_box'>
                {/* 테이블 컴포넌트 */}
                {/* 검색창 */}
                <div className={`search_container_wrap ${type === "EventRegist" ? "event_regist" : ""}`}>
                    {type == "EventRegist" ? (
                        <>
                            <span>현재 신청인 : <b>{eventAttenCount}</b>명</span>
                        </>
                    ):(
                        <></>
                    )}
                    <div className="search_container">
                        <Select className='p_select p_table_select' value={searchCategory} onChange={handleSearchCategoryChange}>
                            {categoryOptions.map(option => (
                                <Option key={option.value} value={option.value} className="p_table_option">{option.label}</Option>
                            ))}
                        </Select>
                        <Input className='p_input p_table_search_input' placeholder="검색어를 입력해주세요." value={searchText} onChange={handleSearchTextChange} />
                        <button className='p_search_icon'></button>
                    </div>
                </div>
                <Table
                    columns={updatedColumns}
                    dataSource={filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
                    pagination={false}
                    rowKey="idx"
                    locale={{ emptyText: '내역이 없습니다' }}
                    onRow={(record) => ({
                        onClick: () => handleRowClick(record),
                    })}
                />
                {/* 페이지 네비게이션 */}
                <Pagination
                    current={currentPage}
                    total={filteredData.length}
                    pageSize={pageSize}
                    onChange={handlePageChange}
                />
            </div>
        </>
    );
}

export default TableList;
